import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import Select from "react-select";
import secureLocalStorage from "react-secure-storage";
import { VARIABLES } from "../../Constant";
import CreateProductModal from "../Product/CreateProductModal";
import RequiredQuantityInput from "./RequiredQuantityInput";

const CreateBOM = () => {
    const userID = secureLocalStorage.getItem("userID");
    const delay_time = VARIABLES.delayTime;
    const navigate = useNavigate();

    const [duplicateFrom, setDuplicateFrom] = useState(null);

    // select dropdown
    const [productData, setProductData] = useState([]);
    const [variant, setVariant] = useState([]);
    const [item, setItem] = useState([]);
    const [department, setDepartment] = useState([]);
    const [supplier, setSupplier] = useState([]);

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading, isFetching } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useCreate } = useAPIQuery({
        key: "bom",
        endpoint: "/api/bom/",
    });

    const { useFetch: useFetchBom } = useAPIQuery({
        key: "bom",
        endpoint: "/api/bom/",
    });

    const { data: boms, isFetching: fetchingBoms } = useFetchBom({
        params: {
            action: "BOM-code",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useFetch: useFetchPendingBom } = useAPIQuery({
        key: "bom-pending-boms",
        endpoint: "/api/bom/",
    });

    const { data: pendingBoms, isFetching: fetchingPendingBoms } =
        useFetchPendingBom({
            params: {
                action: "Pending-BOM",
            },
            abortOnNewRequest: true,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 3,
            retry: 3,
            keepPlaceholder: true,
            refetchOnReconnect: true,
        });

    console.log(pendingBoms);

    const { useFetch: BOMFetch } = useAPIQuery({
        key: "bom",
        endpoint: `/api/bom/`,
    });

    const { data: Bomdata, isFetching: isBomFetching } = BOMFetch({
        params: {
            product_id: duplicateFrom?.value,
            action: "fetch_bom",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
        enabled: !!duplicateFrom,
    });

    console.log(Bomdata);

    const handleCreateBOM = (data) => {
        Swal.fire({
            title: "BOM Added!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        });
    };

    const handleErrorBOM = (data) => {
        Swal.fire({
            title: "Error Adding BOM",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useCreate({
        onSuccess: handleCreateBOM,
        onError: handleErrorBOM,
        retry: 2,
    });

    // react Hook form Props
    const {
        control,
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
        setValue,
        trigger,
    } = useForm({
        defaultValues: {
            bulk_order: [
                {
                    item_id: "",
                    department: "",
                    req_quan_of_item: "",
                    supplier: "",
                    no_shades: 0,
                    // mould_sizes: "",
                },
            ],
        },
        mode: "onChange",
    });

    const { fields, append, remove } = useFieldArray({
        control,
        name: "bulk_order",
    });

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        console.log(data);
        var bom = {
            final_good: data?.final_good?.value,
            product_id: data.product_id.value,
            variant: data.variant.value,
            no_shades: data.no_shades,
            created_by: userID,
            updated_by: userID,
            bulk_upload: data.bulk_order.map((api) => {
                return {
                    item_id: api.item_id?.value,
                    department: api.department?.value,
                    req_quan_of_item: api.req_quan_of_item,
                    item_per_product: 1,
                    supplier_id: api.supplier?.value,
                    // mould_sizes: api.mould_sizes,
                };
            }),
        };

        mutate({
            data: bom,
        });
    };

    useEffect(() => {
        const editBOM = Bomdata?.data;
        console.log(editBOM);
        // defaultValues is a react form hook.
        if (editBOM) {
            var defaultValues = {};
            defaultValues.bulk_order = editBOM.bom_details.map((bo) => ({
                ...bo,
                item_id: {
                    value: bo.item_id,
                    label: bo.item__item_name,
                    uom: bo?.item__uom,
                },
                department: {
                    value: bo.department,
                    label: bo.department,
                },
                supplier: {
                    value: bo.supplier_id,
                    label:
                        bo.supplier__user__first_name +
                        " " +
                        bo.supplier__user__last_name,
                },
                bulk_order_id: bo.id,
                // mould_sizes: bo.mould_sizes,
            }));

            console.log(defaultValues);

            reset({
                ...defaultValues,
            });
        }
    }, [Bomdata]);

    useEffect(() => {
        if (data) {
            setProductData(data.item.filter((api) => api.category === "FG"));
            setVariant(
                data.typemaster?.filter(
                    (post) => post.category_value == "variant"
                )
            );
            setItem(
                data.item.filter(
                    (api) =>
                        api.category === "WIP" ||
                        api.category === "Raw Material"
                )
            );
            setDepartment(
                data.department?.map((dept) => ({
                    value: dept?.department_name,
                    label: dept?.department_name,
                }))
            );
            setSupplier(data.supplier);
        }
    }, [data]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> Create BOM </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="card">
                    <div className="card-inner">
                        <div className="row g-4 mb-3 d-flex align-items-end">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <label className="form-label">
                                    Duplicate BOM
                                </label>
                                <Select
                                    options={boms?.map((bom) => {
                                        return {
                                            label: bom.product__item_name,
                                            value: bom.product_id,
                                        };
                                    })}
                                    onChange={(val) => {
                                        if (val === null) {
                                            reset({
                                                bulk_order: [
                                                    {
                                                        item_id: null,
                                                        department: null,
                                                        supplier: null,
                                                        bulk_order_id: null,
                                                    },
                                                ],
                                            });
                                        } else {
                                            setDuplicateFrom(val);
                                        }
                                    }}
                                    isLoading={fetchingBoms || isLoading}
                                    isDisabled={fetchingBoms || isLoading}
                                    isClearable={true}
                                />
                            </div>
                            {isBomFetching ? (
                                <div
                                    className="spinner-border text-primary ms-2 mb-1"
                                    role="status"
                                >
                                    <span className="sr-only"></span>
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="border mb-3"></div>
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Final Good
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="w-100 me-2">
                                            <Controller
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        options={
                                                            productData?.map(
                                                                (api) => {
                                                                    return {
                                                                        label: api.item_name,
                                                                        value: api.id,
                                                                        item_code:
                                                                            api.item_code,
                                                                        bom_code:
                                                                            api.bom_code,
                                                                    };
                                                                }
                                                            ) ?? []
                                                        }
                                                        isLoading={
                                                            isLoading ||
                                                            fetchingPendingBoms ||
                                                            isBomFetching
                                                        }
                                                        isDisabled={
                                                            isLoading ||
                                                            fetchingPendingBoms ||
                                                            isBomFetching
                                                        }
                                                        isClearable={true}
                                                        id="select-forms-product_id"
                                                    />
                                                )}
                                                defaultValue=""
                                                rules={{ required: true }}
                                                name="final_good"
                                                control={control}
                                            />
                                        </div>
                                    </div>
                                    {errors.final_good && (
                                        <span className="fs-8 text-danger">
                                            Final good is required
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Product / WIP
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="w-100 me-2">
                                            <Controller
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        options={
                                                            pendingBoms?.data?.map(
                                                                (api) => {
                                                                    return {
                                                                        label: api.item_name,
                                                                        value: api.id,
                                                                    };
                                                                }
                                                            ) ?? []
                                                        }
                                                        isLoading={
                                                            isLoading ||
                                                            fetchingPendingBoms ||
                                                            isBomFetching
                                                        }
                                                        isDisabled={
                                                            isLoading ||
                                                            fetchingPendingBoms ||
                                                            isBomFetching
                                                        }
                                                        isClearable={true}
                                                        id="select-forms-product_id"
                                                    />
                                                )}
                                                defaultValue=""
                                                rules={{ required: true }}
                                                name="product_id"
                                                control={control}
                                            />
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-bs-toggle="modal"
                                            data-bs-target="#create-item-modal"
                                            disabled={
                                                isLoading ||
                                                fetchingBoms ||
                                                isFetching
                                            }
                                        >
                                            +
                                        </button>
                                    </div>
                                    {errors.product_id && (
                                        <span className="fs-8 text-danger">
                                            Product is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Variant
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={variant?.map((api) => {
                                                    return {
                                                        value: api.name,
                                                        label: api.name,
                                                    };
                                                })}
                                                isLoading={
                                                    isLoading ||
                                                    isFetching ||
                                                    isBomFetching
                                                }
                                                isDisabled={
                                                    isLoading ||
                                                    isFetching ||
                                                    isBomFetching
                                                }
                                                isClearable={true}
                                                id="select-forms-variant"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="variant"
                                        control={control}
                                    />
                                    {errors.variant && (
                                        <span className="fs-8 text-danger">
                                            Variant is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        No of Shades
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter no of shades"
                                        id="text-forms-no_shades"
                                        {...register("no_shades", {
                                            required: true,
                                        })}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                    {errors.no_shades && (
                                        <span className="fs-8 text-danger">
                                            No of Shades is required
                                        </span>
                                    )}
                                </div>

                                <div className="border"></div>

                                {fields.map((field, index) => (
                                    <div className="row g-4" key={field.id}>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label className="form-label">
                                                Item
                                                <span className="fs-8 text-danger">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                            <Controller
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        options={item?.map(
                                                            (api) => {
                                                                return {
                                                                    value: api.id,
                                                                    label: api.item_name,
                                                                    ...api,
                                                                };
                                                            }
                                                        )}
                                                        isLoading={
                                                            isLoading ||
                                                            isFetching ||
                                                            isBomFetching
                                                        }
                                                        isDisabled={
                                                            isLoading ||
                                                            isFetching ||
                                                            isBomFetching
                                                        }
                                                        isClearable={true}
                                                        id="select-forms-item_id"
                                                    />
                                                )}
                                                defaultValue=""
                                                rules={{ required: true }}
                                                name={`bulk_order.${index}.item_id`}
                                                control={control}
                                            />
                                            {errors.bulk_order?.[index]
                                                ?.item_id && (
                                                <span className="fs-8 text-danger">
                                                    Item is required
                                                </span>
                                            )}
                                        </div>

                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label className="form-label">
                                                Department
                                                <span className="fs-8 text-danger">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                            <Controller
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        options={
                                                            department ?? []
                                                        }
                                                        isLoading={
                                                            isLoading ||
                                                            isFetching ||
                                                            isBomFetching
                                                        }
                                                        isDisabled={
                                                            isLoading ||
                                                            isFetching ||
                                                            isBomFetching
                                                        }
                                                        isClearable={true}
                                                        id="select-forms-department"
                                                    />
                                                )}
                                                defaultValue=""
                                                rules={{ required: true }}
                                                name={`bulk_order.${index}.department`}
                                                control={control}
                                            />
                                            {errors.bulk_order?.[index]
                                                ?.department && (
                                                <span className="fs-8 text-danger">
                                                    Department is required
                                                </span>
                                            )}
                                        </div>

                                        <RequiredQuantityInput
                                            index={index}
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            errors={errors}
                                            trigger={trigger}
                                        />

                                        {/* <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label className="form-label">
                                                Required Quantity of Item
                                                <span className="fs-8 text-danger">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                            <div className="row">
                                                <div className="col-2">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        {...register(
                                                            `bulk_order.${index}.numerator`,
                                                            {
                                                                required: false,
                                                            }
                                                        )}
                                                        onWheel={(e) =>
                                                            e.target.blur()
                                                        }
                                                    />
                                                </div>
                                                <div className="col-2">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        {...register(
                                                            `bulk_order.${index}.denominator`,
                                                            {
                                                                required: false,
                                                                validate: {
                                                                    positive: (
                                                                        value
                                                                    ) =>
                                                                        value !==
                                                                            0 ||
                                                                        "Zero is not allowed",
                                                                },
                                                            }
                                                        )}
                                                        onWheel={(e) =>
                                                            e.target.blur()
                                                        }
                                                    />
                                                </div>
                                                <div className="col-8">
                                                    <div className="input-group">
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control"
                                                            placeholder="Enter required quantity of item"
                                                            id="email-forms-req_quan_of_item"
                                                            {...register(
                                                                `bulk_order.${index}.req_quan_of_item`,
                                                                {
                                                                    required:
                                                                        "Required Quantity of Item is required",
                                                                    validate: {
                                                                        positive:
                                                                            (
                                                                                value
                                                                            ) =>
                                                                                value >
                                                                                    0 ||
                                                                                "Only positive numbers are allowed",
                                                                    },
                                                                }
                                                            )}
                                                            onWheel={(e) =>
                                                                e.target.blur()
                                                            }
                                                        />
                                                        {watch(
                                                            `bulk_order.${index}.item_id`
                                                        ) && (
                                                            <div className="input-group-append">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="basic-addon2"
                                                                >
                                                                    {
                                                                        watch(
                                                                            `bulk_order.${index}.item_id`
                                                                        )?.uom
                                                                    }
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {errors.bulk_order?.[index]
                                                ?.req_quan_of_item && (
                                                <span className="fs-8 text-danger">
                                                    {
                                                        errors.bulk_order?.[
                                                            index
                                                        ]?.req_quan_of_item
                                                            .message
                                                    }
                                                </span>
                                            )}
                                        </div> */}

                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label className="form-label">
                                                Supplier Name
                                                <span className="fs-8 text-danger">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                            <Controller
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        options={supplier?.map(
                                                            (api) => {
                                                                return {
                                                                    value: api.id,
                                                                    label:
                                                                        api.first_name +
                                                                        " " +
                                                                        api.last_name,
                                                                };
                                                            }
                                                        )}
                                                        isLoading={
                                                            isLoading ||
                                                            isFetching ||
                                                            isBomFetching
                                                        }
                                                        isDisabled={
                                                            isLoading ||
                                                            isFetching ||
                                                            isBomFetching
                                                        }
                                                        isClearable={true}
                                                        id="select-forms-supplier"
                                                    />
                                                )}
                                                defaultValue=""
                                                rules={{ required: true }}
                                                name={`bulk_order.${index}.supplier`}
                                                control={control}
                                            />
                                            {errors.bulk_order?.[index]
                                                ?.item_per_product && (
                                                <span className="fs-8 text-danger">
                                                    Supplier Name is required
                                                </span>
                                            )}
                                        </div>

                                        {/* <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label className="form-label">
                                                Mould Size
                                                <span className="fs-8 text-danger">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="ex: 2,6,10"
                                                id="text-forms-no_shades"
                                                {...register("mould_sizes", {
                                                    required:
                                                        "Mould sizes are required",
                                                    pattern: {
                                                        value: /^(\d+)(,\d+)*$/,
                                                        message:
                                                            "Enter valid sizes like 2,6,10",
                                                    },
                                                })}
                                            />
                                            {errors.mould_sizes && (
                                                <span className="fs-8 text-danger">
                                                    {
                                                        errors.mould_sizes
                                                            ?.message
                                                    }
                                                </span>
                                            )}
                                        </div> */}

                                        <div className="col-lg-12 col-md-3 col-sm-12">
                                            <div className="d-flex">
                                                <button
                                                    type="button"
                                                    className="btn btn-md me-3 btn-outline-primary"
                                                    onClick={() =>
                                                        append({
                                                            item_id: "",
                                                            department: "",
                                                            req_quan_of_item:
                                                                "",
                                                            item_per_product:
                                                                "",
                                                            supplier: "",
                                                            // mould_sizes: "",
                                                        })
                                                    }
                                                >
                                                    Add
                                                </button>
                                                {index !== 0 && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-md btn-outline-danger"
                                                        onClick={() =>
                                                            remove(index)
                                                        }
                                                    >
                                                        Delete
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-bom-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-create-bom"
                                                disabled={
                                                    isLoading ||
                                                    isBomFetching ||
                                                    isFetching ||
                                                    fetchingPendingBoms
                                                }
                                            >
                                                Create
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <CreateProductModal />
        </>
    );
};

export default CreateBOM;
